import React from 'react';
import PropTypes from 'prop-types';

import { SecondaryButton } from '../secondary-button';
import { SimpleButton } from '../simple-button';
import { AddressHelper } from '../../helpers/AddressHelper';
import styles from './AddressCard.css';

const BUTTON_TYPES = {
  SELECT: 'select',
  EDIT: 'edit',
};

const IPropTypes = {
  address: PropTypes.shape({
    additionalData: PropTypes.string,
    addressType: PropTypes.string.isRequired,
    cityName: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string.isRequired,
    }).isRequired,
    firstCorner: PropTypes.string,
    deliveryDisabled: PropTypes.bool.isRequired,
    department: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string.isRequired,
    }).isRequired,
    doorNumber: PropTypes.string,
    id: PropTypes.string.isRequired,
    streetName: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  onButtonClick: PropTypes.func.isRequired,
  buttonType: PropTypes.oneOf(Object.values(BUTTON_TYPES)).isRequired,
};

const defaultProps = {
  className: '',
};

const MAX_NOTES_LENGTH = 80;

const AddressCard = props => (
  <div className={[styles.container, props.className].join(' ')}>
    <div>
      <h4 className={styles.street}>
        {props.address.streetName} {props.address.doorNumber}
      </h4>
      <p className={styles.info}>
        {AddressHelper.getAddressType(props.address.addressType)}
      </p>
      {
        props.address.firstCorner &&
        <p className={styles.info}>
          Esq. {props.address.firstCorner}
        </p>
      }
      <p className={styles.info}>
        {props.address.cityName ? `${props.address.cityName.name}, ` : ''}{props.address.department.name}
      </p>
      {
        props.address.additionalData &&
        <p className={styles.info}>
          {
            props.address.additionalData.length > MAX_NOTES_LENGTH
              ? `${props.address.additionalData.slice(0, MAX_NOTES_LENGTH).trim()}...`
              : props.address.additionalData
          }
        </p>
      }
    </div>
    <div className={styles.buttonContainer}>
      {
        props.address.deliveryDisabled &&
        <p className={styles.error}>
          Lamentablemente ya no enviamos a esta dirección.
        </p>
      }
      {
        props.buttonType.includes(BUTTON_TYPES.SELECT) &&
        <SecondaryButton
          className={styles.button}
          disabled={props.address.deliveryDisabled}
          onClick={() => props.onButtonClick(props.address.id)}
        >
          Utilizar Esta
        </SecondaryButton>
      }
      {
        props.buttonType.includes(BUTTON_TYPES.EDIT) &&
        <SimpleButton
          className={styles.button}
          onClick={() => props.onButtonClick(props.address)}
        >
          Editar
        </SimpleButton>
      }
    </div>
  </div>
);

AddressCard.propTypes = IPropTypes;
AddressCard.defaultProps = defaultProps;

export { AddressCard, BUTTON_TYPES };



// WEBPACK FOOTER //
// ./src/common/address-card/AddressCard.jsx